import { render, staticRenderFns } from "./PriceCell.vue?vue&type=template&id=2c93e34b&"
import script from "./PriceCell.vue?vue&type=script&lang=js&"
export * from "./PriceCell.vue?vue&type=script&lang=js&"
import style0 from "./PriceCell.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports